import React from "react";

export default function ProductSpecificationsData(minAge, maxAge) {
  return {
      video: {
        name: "Why purchase Life Insurance?",
        link: "https://player.vimeo.com/video/213549517"
      },
      hideNeedsAnalysis:true,
      hideVideoLink:true,
      image: "product-landing/disa/circle1.png",
      specs: [
          {
              title: "Disability Insurance",
              text: "Long-term disability insurance replaces a portion of your monthly income. You can use your benefit to pay the mortgage, buy groceries, cover out-of-pocket medical expenses – literally whatever you need. With instant quotes and an easy online application, you can ensure your income in case you become too sick or hurt to work.",
          },
          {
              title: "Eligibility",
              text: `${minAge}-${maxAge} years`,
          },
          {
              title: "Benefit amounts",
              text: <span>Up to $35,000 monthly<br/>Benefits replace up to 60% of monthly income</span>,
          },
          {
              title: "Who can apply?",
              text: `U.S. citizens or permanent residents ages ${minAge}-${maxAge}`
          },
          {
            title: "Elimination periods",
            text: "30, 60, 90, 180 or 365 days",
          },
          {
              title: "Benefit Period",
              text: "2 years, 5 years, To Age 65, To Age 67 or To Age 70"
          }
      ],
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LongTermDisability/ProductSpecificationsData.js